import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import configData from '../config.json';

export const useLagTime = () => {
  const [lagTime, setLagTime] = useState(30); // Default to 30 minutes
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch lag time from server
  const fetchLagTime = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await axios({
        method: 'GET',
        url: `${configData.SERVER_URL}/config/mobile/fetch`,
      });

      // Find lag time configuration
      const lagTimeConfig = response.data?.find?.((a) => a.Name === 'lagTime');
      if (lagTimeConfig?.Value?.duration) {
        setLagTime(parseInt(lagTimeConfig.Value.duration));
      }
      setError(null);
    } catch (error) {
      console.error('Error fetching lag time configuration:', error);
      setError(error);
      // Keep using default lag time if there's an error
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Fetch lag time on component mount
  useEffect(() => {
    fetchLagTime();
  }, [fetchLagTime]);

  return {
    lagTime,
    isLoading,
    error,
    fetchLagTime,
  };
};
